import './js/web2py.js';
import './js/web2py-bootstrap4.js';
import './js/isrmcomponents.js';
import './scss/style.scss';
import './css/w2p/calendar.css';
import './css/selectize.bootstrap3.css';
import './css/w2p/font-awesome.min.css';
import './css/w2p/web2py-bootstrap4.css';
